export const flags = { env: import.meta.env.VITE_APP_ENV } as const;
